import React from "react";
import PiggyBank from "../../images/piggy-bank.png";

const AspireCrossSell = (props) => {
  return (
    <div className="container-fluid cross-sell-container" style={{ marginBottom: "-40px" }}>
      <div className="row">
        <div className="col-auto d-flex">
          <img src={PiggyBank} alt="Lake Trust Credit Union" width="75" height="75" />
        </div>

        <div className="col">
          <span style={{ fontWeight: "bold" }}>Build your savings faster.</span> <br />
          Earn 3.00% APY on the first $5,000 in your Aspire Savings account.{" "}
          <a className="cross-sell-link" href="http://laketrust.org/aspiresavings">
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
};

export default AspireCrossSell;



// WEBPACK FOOTER //
// ./src/components/cross-sells/aspire-cross-sell.component.js